<template>
  <!-- paginacija se iscrtava u browseru: roditeljska stranica (pages/oglasi.vue) se renderuje pre liste, pa server jos ne zna
       last_page; sa ClientOnly nema neslaganja pri hidraciji, a min-height cuva mesto da stranica ne skace -->
  <div class="pagination-items" style="min-height: 40px">
    <ClientOnly>
      <vue-awesome-paginate
        :total-items="totalItems"
        :items-per-page="1"
        :max-pages-shown="5"
        v-model="currentPage"
        @click="goToPage"
      />
    </ClientOnly>
  </div>
</template>

<script setup>
import { VueAwesomePaginate } from 'vue-awesome-paginate'

import { computed, ref, watch } from 'vue'
import { usePaginationStore } from "~/stores/pagination"
import FilterDataByRoute from '~/components/cmsCustomer/advertisement/utils/FilterDataByRoute'

const { getPage } = FilterDataByRoute()

const store = usePaginationStore()
const route = useRoute()
const router = useRouter()

// total pages (vue-awesome-paginate očekuje total-items; ti koristiš items-per-page=1 pa je to isto što i lastPage)
const totalItems = computed(() => Number(store.lastPage || 1))

// current page treba da prati rutu (da radi i bez refresh-a)
const currentPage = ref(Number(getPage()) || 1)

watch(
  () => route.fullPath,
  () => {
    currentPage.value = Number(getPage()) || 1
  },
  { immediate: true }
)

// base path: ukloni poslednji segment (page) posle poslednje /
const basePath = computed(() => {
  const path = route.fullPath.split('?')[0] // ako ima query, izbaci ga
  return path.replace(/\/[^/]*$/, '/')      // skini poslednji segment i ostavi trailing /
})

const goToPage = async () => {
  await router.push(basePath.value + String(currentPage.value))
}
</script>
